import { Anchor, PageHeading } from 'components/atoms';
import { Head, PageLayout } from 'components/molecules';
import { getTranslations } from 'i18n';
import type { GetServerSideProps, NextPage } from 'next';
import React from 'react';
import { renderContentBlock } from 'utils';
import { useTranslation } from 'utils/hooks';
import { RichTextComponent } from 'utils/hooks/useTranslation';

const AgbPage: NextPage = () => 
{
  const translations = useTranslation('agb');
  const { t } = translations;

  const richComponents: Record<string, RichTextComponent> = {
    privacy: <Anchor href="/datenschutz" />,
    rol: <ol className="roman"></ol>,
  };

  return (
    <PageLayout textContentPage>

      <Head title={t('agb:meta.title')}>
        <meta name="description" content={t('agb:meta.description')} />
        <meta name="keywords" content={t('agb:meta.keywords')} />
      </Head>

      <PageHeading title={t('agb:heading')} />

      <div style={{ display:'flex', justifyContent: 'space-between' }}>
        <p>{t('agb:version')}</p>
        <Anchor href={'/agb-b2c'}>{t('agb:toB2c')}</Anchor>
      </div>

      <div className="noListStyles">
        <ol>

          {renderContentBlock('agb:content', translations, richComponents)}

        </ol>
      </div>
    </PageLayout>
  );
};

export default AgbPage;

export const getServerSideProps: GetServerSideProps = async (ctx) =>
{
  const { locale } = ctx;
  const translations = await getTranslations(locale, 'agb');

  return { props: { ...translations } };
};
